import { db } from '../firebase';
import { collection, query, where, getDocs, addDoc } from '../firestore-compat';

/**
 * Notifica um usuário quando uma nova tarefa for atribuída a ele.
 * 
 * @param {string} taskDescription - Descrição/Título da tarefa.
 * @param {string|string[]} assignedUsers - Nome(s) do(s) usuário(s) atribuído(s) (pode ser array ou string).
 * @param {string} currentUserName - Nome do usuário que está atribuindo a tarefa.
 * @param {string} projectName - Nome do projeto de origem (ex: "Projeto IW").
 */
export async function notifyNewTaskAssigned(taskDescription, assignedUsers, currentUserName, projectName) {
    if (!assignedUsers) return;

    const userNames = Array.isArray(assignedUsers) ? assignedUsers : [assignedUsers];
    
    // Filtra para não enviar notificação para si mesmo
    const targets = userNames.filter(name => name && name !== currentUserName);
    if (targets.length === 0) return;

    try {
        const notificationPromises = targets.map(async (targetName) => {
            const q = query(collection(db, 'users'), where('name', '==', targetName));
            const snap = await getDocs(q);

            if (snap.empty) {
                console.warn(`[NOTIFY] User not found by name: ${targetName}`);
                return;
            }

            const destinatarioUid = snap.docs[0].data().uid || snap.docs[0].id;

            return addDoc(collection(db, 'notificacoes'), {
                tipo: 'nova_tarefa',
                destinatarioUid,
                lida: false,
                dataNotificacao: new Date().toISOString(),
                titulo: `Nova Tarefa: ${projectName}`,
                mensagem: `${currentUserName} atribuiu a você a tarefa "${taskDescription}".`,
                eventoDescricao: taskDescription,
                atribuidoPor: currentUserName
            });
        });

        await Promise.all(notificationPromises);
        console.log(`[NOTIFY] Sent new task notification for task "${taskDescription}"`);
    } catch (error) {
        console.error('[NOTIFY] Error sending new task notification:', error);
    }
}
